var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup578(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.121,
    height: 12.243,
    viewBox: "0 0 7.121 12.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(-496.939 -643.818)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    y1: 5,
    x2: 5.061,
    transform: "translate(498 655) rotate(-90)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x1: 5.061,
    y1: 5,
    transform: "translate(498 649.939) rotate(-90)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup578);
export default __webpack_public_path__ + "static/media/Group 578.c584efd7cfcb03b58f59bddb8e399bc7.svg";
export { ForwardRef as ReactComponent };